module.exports = __webpack_public_path__ + "media/images/flags/1x1/lie-bc873824f6160911d35db1ef25c882a4.svg";